const mixin = {
  props: {
    size: Number
  },
  computed: {
    sizeClasses() {
      return ['col-12', `col-sm-${this.size}`];
    }
  }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/dynamicSize.js